import { render, staticRenderFns } from "./leave_word.vue?vue&type=template&id=4e4367e4&scoped=true&"
import script from "./leave_word.vue?vue&type=script&lang=js&"
export * from "./leave_word.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4367e4",
  null
  
)

export default component.exports